import { render, staticRenderFns } from "./IntroContent.vue?vue&type=template&id=22b2be54&"
import script from "./IntroContent.vue?vue&type=script&lang=js&"
export * from "./IntroContent.vue?vue&type=script&lang=js&"
import style0 from "./IntroContent.vue?vue&type=style&index=0&id=22b2be54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports